import React, {useEffect, useState, useRef, useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import "./style.scss";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ServiceType from "../../components/ServiceType";
import moment from "moment";
import "moment-timezone";
import {
  setCustomerSlotDetails,
  getCustomerSlotDetails,
} from "../../services/SessionStorage";
import Loader from "../../components/Loader";
import "../../components/Loader/style.scss";
import {
  createTurneroDropdownCompatibleStoreData,
  getValueFromArrOfObj,
} from "../../util";
import TabsMenu from "../../components/TabsMenu";
import {setModuleIds, setSelectedStoreDetails} from "../../actions/store";
import {getFirebase} from "../../services/firebaseclient";
import {setFirebaseToken, setSelectedServiceRedux} from "../../actions/account";
import {
  getModuleByDeskId,
  getTotem,
} from "../../services/turnero/turnero.service";
import BuSpecificHeader from "../../components/Header/BuSpecificHeader";
import {getQueueStatusFromStore} from "../../services/queue/queue.service";
import {getFirebaseToken} from "../../services/firebase/firebase.service";
import StoreHeader from "../StoreHeader";
import {
  getStoreByNodeId,
  getStoreDetails,
} from "../../services/store/store.service";

const SelectTurneroStoreAndType = () => {
  const {urlTotemId} = useSelector((state) => {
    return {
      urlTotemId: state.globalReducer?.urlTotemId,
    };
  });
  const customerSlotDetails = useRef(getCustomerSlotDetails());
  const [loading, setLoading] = useState(false);
  const [serviceLoader, setServiceLoader] = useState(false);
  const [isServiceAvailable, setIsServiceAvailable] = useState(false);
  const [availableStores, setAvailableStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState({});
  const navigate = useNavigate();
  const currDate = useRef("test");
  const [queueStatus, setQueueStatus] = useState([]);
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const onQueueBooking = async (service) => {
    if (service?.isCustomerIdRequired && !customerSlotDetails.current?.userId) {
      dispatch(setSelectedServiceRedux(service));
      navigate("/customer/customerInfo", {replace: true});
    } else {
      customerSlotDetails.current.selectedQueueService = {
        ...service,
        uuid: service?.serviceTypeId,
      };
      customerSlotDetails.current.selectedQueueService["from"] = "customerInfo";
      setCustomerSlotDetails(customerSlotDetails.current);
      navigate("/customer/bookQueue", {replace: true});
    }
  };

  const processGetStoreDetails = useCallback(async (country, bu, source) => {
    try {
      setLoading(true);
      let response = await getStoreDetails(bu, source, country);

      const modifiedStoreData = createTurneroDropdownCompatibleStoreData(
        response.stores
      );

      if (customerSlotDetails.current?.nodeId !== null) {
        const {uuid} = await getStoreByNodeId(
          customerSlotDetails.current?.nodeId
        );
        const onlyStore = modifiedStoreData.filter((item) => {
          return item.uuid === uuid;
        });
        setSelectedStore(onlyStore[0]);
        setAvailableStores([onlyStore[0]]);
      } else if (modifiedStoreData.length) {
        setAvailableStores(modifiedStoreData);
        setSelectedStore(modifiedStoreData[0]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    } finally {
    }
  }, []);

  const getQueueStatus = useCallback(async (selectedStore) => {
    /*let params = null;
    const queueStatusUrl = config.endPoints.queueStatus;
    const storeIdPlaceholder = /storeIdPlaceholder/gi;
    const url = queueStatusUrl.replace(storeIdPlaceholder, selectedStore.uuid);
    params = {
      priority: 0,
    };
    if (urlTotemId?.length > 0) {
      params = {
        ...params,
        totemId: urlTotemId,
      };
    }*/
    const selectedStoreUuid = selectedStore.uuid;
    try {
      setLoading(true);
      let response = await getQueueStatusFromStore(
        selectedStoreUuid,
        urlTotemId
      ); //API.get(url, {params});
      //response = await processApiResponse(response);
      let eligibleQueueList = [];
      if (response?.length) {
        eligibleQueueList = response.filter((queue) => {
          return queue?.desks?.length > 0 && queue?.numberOfModules > 0;
        });
      }
      setQueueStatus(eligibleQueueList);
    } catch (error) {
      navigate("*");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (selectedStore && selectedStore.uuid) {
      dispatch(setSelectedStoreDetails(selectedStore));
      customerSlotDetails.current.currentBookingDetails = {selectedStore};
      let customerPhoneNumber = null;
      if (
        customerSlotDetails.current.customerPhoneNumberWithoutCode &&
        customerSlotDetails.current.customerPhoneNumberWithoutCode.length
      ) {
        customerPhoneNumber = `${selectedStore.stdCode}${customerSlotDetails.current.customerPhoneNumberWithoutCode}`;
      }
      // const customerPhoneNumber = `${selectedStore.stdCode}${customerSlotDetails.current.customerPhoneNumberWithoutCode}`;
      setCustomerSlotDetails({
        ...customerSlotDetails.current,
        customerPhoneNumber,
      });
      getQueueStatus(selectedStore);
    }
  }, [getQueueStatus, selectedStore]);

  useEffect(() => {
    async function checkLocation() {
      processGetStoreDetails(
        customerSlotDetails.current.country,
        customerSlotDetails.current.bu,
        customerSlotDetails.current.source
      );
    }
    checkLocation();
  }, [processGetStoreDetails]);

  useEffect(() => {
    const currTimeDate = moment.tz(moment(), customerSlotDetails.timeZone);
    currDate.current = currTimeDate.format("DD MMM, YYYY");
  }, []);

  const {firebaseToken, moduleIds, urlLinkSource, isLoggedInUser} = useSelector(
    (state) => {
      return {
        firebaseToken: state.account?.firebaseToken,
        moduleIds: state.store?.moduleIds,
        urlLinkSource: state.globalReducer?.urlLinkSource || null,
        isLoggedInUser: state.customerReducer?.isLoggedInUser,
      };
    }
  );
  const [serviceAvailable, setServiceAvailable] = useState([]);
  useEffect(() => {
    if (moduleIds?.length) moduleFirebaseChanges();
  }, [moduleIds]);

  useEffect(() => {
    if (selectedStore?.uuid) {
      if (urlTotemId?.length > 0) getTotemDetails();
      else getModuleIds();
    }
  }, [selectedStore, urlTotemId]);

  const getProcessFirebaseToken = async () => {
    setLoading(true);
    const response = await getFirebaseToken();
    //("getFirebaseToken", response);
    setFirebaseToken(response);
    setLoading(false);
    return response;
    /*getFirebaseToken()
      .then(processApiResponse)
      .then((response) => {
        setFirebaseToken(response);
        setLoading(false);
        return response;
      });*/
  };

  const moduleFirebaseChanges = async () => {
    setServiceLoader(true);
    let tokenToUse = firebaseToken;
    if (!firebaseToken) tokenToUse = await getProcessFirebaseToken();
    const instance = await getFirebase(tokenToUse);
    const fi = await instance?.database();
    fi?.ref(`/${selectedStore.uuid}/modules`).on("value", (snapshot) => {
      const selectedService = new Set();
      const data = snapshot.val();
      if (data) {
        moduleIds.map((moduleId) => {
          if (moduleId) {
            const module = data[moduleId];
            if (module?.isVisible && module?.selectedServices)
              module?.selectedServices?.forEach((serviceId) =>
                selectedService.add(serviceId)
              );
          }
        });
      }
      setServiceAvailable([...selectedService]);
      setServiceLoader(false);
    });
  };

  const getModuleIds = async () => {
    setServiceLoader(true);
    const res = await getModuleByDeskId({storeId: selectedStore.uuid});
    const moduleIds = res.data?.modules?.map((module) => {
      return module.uuid;
    });
    dispatch(setModuleIds([...moduleIds]));
    setServiceLoader(false);
    return moduleIds;
  };

  const getTotemDetails = () => {
    setServiceLoader(true);
    getTotem(urlTotemId).then((res) => {
      const deskIds = getValueFromArrOfObj(res?.data?.desks, "uuid");
      const modules = [];
      deskIds.map((deskId) =>
        modules.push(getModuleByDeskId({storeId: selectedStore?.uuid, deskId}))
      );
      Promise.all(modules).then((data) => {
        const moduleIds = [];
        data?.forEach((item) => {
          item?.data?.modules?.forEach((module) => {
            moduleIds.push(module.uuid);
          });
        });
        dispatch(setModuleIds([...moduleIds]));
        setServiceLoader(false);
      });
    });
  };

  useEffect(() => {
    if (queueStatus.length > 0 && serviceAvailable.length > 0) {
      queueStatus.map((service) => {
        if (serviceAvailable.includes(service.serviceTypeId))
          setIsServiceAvailable(true);
      });
    }
  }, [queueStatus, serviceAvailable]);
  return loading ? (
    <div className="loader-container">
      <Loader />
    </div>
  ) : (
    <>
      {urlLinkSource === "web" ? <BuSpecificHeader /> : null}
      {isLoggedInUser && <TabsMenu path="selectTurneroStoreAndType" />}
      <div className="queue-status-container">
        <StoreHeader />
        <div className="serviceSelect-bottom-wrap">
          {isServiceAvailable && (
            <p className="turnero-heading mt-2">{t("selectServiceText")}</p>
          )}
          {!serviceLoader ? (
            <div className="queue-status-details">
              <ServiceType
                services={queueStatus}
                handleServiceSelect={onQueueBooking}
                serviceAvailable={serviceAvailable}
              />
            </div>
          ) : (
            <div className="loader-container service-loader-container">
              <Loader />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SelectTurneroStoreAndType;
